angular.module("digitalLeasing.module").component("insertNewCustomer", {
  templateUrl: "ng/components/digitalLeasing/customerSelection/insertNewCustomer/insertNewCustomer.view.html",
  bindings: {
    model: "=",
    onBack: "&",
    onPressInsert: "&",
    initialCfPiva: "<",
    selectedCfPivaType: "<",
    noCervedData: "&",
    customerIsOk: "&",
    customerIsNotOk: "&",
    cf: "=",
    digitalMode: "<",
    goToNextFromCustomerSelection: "&"
  },
  controllerAs: "InsertNewCustomerCtrl",
  controller: function InsertNewCustomerController(
    FinancialCustomer,
    $cervedService,
    Stato,
    RiUserG,
    $modalService,
    validationService
  ) {
    var self = this;

    self.$onInit = function onInit() {

      self.supportModel = {
        showCervedInfos: false,
        riUserGFromCerved: "",
        searchLoader: false
      }

      self.model.identifier = self.initialCfPiva || "";
      

    };

    self.onClickBack = function () {
        self.onBack();
    };

    self.$onChanges = function (changed) {

        if(changed.initialCfPiva && changed.initialCfPiva.currentValue != self.model.identifier) {
          self.customerIsNotOk()
        } 
       
        self.model.identifier = self.initialCfPiva

        if(self.digitalMode) {
          self.model.identifierType = 'cf';
        } else {
          self.model.identifierType = self.selectedCfPivaType;
        }
  
        self.model = FinancialCustomer.build(self.model);
        console.log("FinancialCustomer: ", self.model);

        if(self.model.identifier != null && typeof self.model.identifier != undefined) {
          self.handleCfChange(self.model.identifier);
        }
        
    };

    var callCervedUpdate = function (identifier) {
      self.supportModel.searchLoader = true;
      $cervedService
        .getCustomer(identifier)
        .then(function (cervedResponse) {
          if (cervedResponse.success) {
            self.supportModel.showCervedInfos = true;
            self.supportModel.riUserGFromCerved = cervedResponse.appCustomerUser.metadata.riUserG;
            self.model = cervedResponse.appCustomerUser;

            if (!self.model.metadata.riUserG.sedeLegale.stato) {
              self.model.metadata.riUserG.sedeLegale.stato = Stato.build();
            }
            console.log("RiUserG: ", self.model.riUserG);

          } else {
            self.customerIsNotOk();
            $modalService.openModal("digitalModalUpdateCerved");
            self.noCervedData();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.supportModel.searchLoader = false;
        });
    }

    self.handleChange = function (values) {
      if(!values.value){
        self.customerIsNotOk();
      } 
    }

    self.handleCfChange = function (cf) {

      if(cf != '' && cf != null && typeof cf != undefined) {

        if(validationService.validateCf(cf)){
          self.model.metadata.riUserG.cf = cf; 
          self.model.cf = cf;
          //self.customerIsOk();
          self.enableConfirmToNextStep = true;
         
        } else if(validationService.checkPiva(cf)) {
          self.model.metadata.riUserG.cf = cf;
          self.model.cf = cf;
          //self.customerIsOk();
          self.enableConfirmToNextStep = true;
         
        } else {
          //self.customerIsNotOk();
          self.enableConfirmToNextStep = false;
        }

      } else {
        //self.customerIsNotOk();
        self.enableConfirmToNextStep = false;
      }

    }

    self.goBackFromCerved = function () {
      self.supportModel.showCervedInfos = false;
    };

    self.updateModel = function (riUserG) {
      if (riUserG) {
        self.customerIsOk();
        riUserG.updateFromCerved = true;
        self.model.metadata.riUserG = RiUserG.build(riUserG);
        console.log("upddate RiUserG model: ", self.model);
      }
    };

    self.openCervedModal = function () {
      $modalService.openModal("refreshCervedData");
      callCervedUpdate(self.model.identifier);
    }

    self.removeCervedModal = function () {
      $modalService.closeModal('refreshCervedData');
    }

    self.goToNext = function () {
      self.goToNextFromCustomerSelection();
    }

  }
});